import {useLocation} from 'react-router'

import BetaToggle from './Toggle'

type Props = {
  /** Wrapper class; only rendered when the toggle is visible on this route. */
  className?: string
}

const HomeworkBetaToggle = ({className}: Props) => {
  const {pathname} = useLocation()

  if (!pathname.startsWith('/institute/homework')) {
    return null
  }

  const toggle = <BetaToggle moduleKey='homework-beta' color='primary' size='sm' title='Homework' />

  return className ? <div className={className}>{toggle}</div> : toggle
}

export default HomeworkBetaToggle
